import { render, staticRenderFns } from "./patientPortalSelectPatient.vue?vue&type=template&id=0517bfd3&"
import script from "./patientPortalSelectPatient.vue?vue&type=script&lang=js&"
export * from "./patientPortalSelectPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports